import React from 'react'
import styled from 'styled-components'
import { ReactComponent as LockedIcon } from 'core-system/Icons/Locked/LockedCircular.svg'

const BlurContainer = styled.div`
  filter: blur(10px);
  user-select: none;
  pointer-events: none;
`
const LockedCircular = styled(LockedIcon)`
  width: 3rem;
  height: 3rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

interface LockedBlurProps {
  children: React.ReactNode
}

const LockedBlur = ({ children, ...props }: LockedBlurProps) => {
  return (
    <>
      <BlurContainer {...props}>{children}</BlurContainer>
      <LockedCircular />
    </>
  )
}

export default React.memo(LockedBlur)
